<template>
  <div>
    <ifac-page-size-select
      v-show="rowData.length > 0"
      v-model="pageSizeChoice"
      :allow-all="allowAll"
      @change="onPageSizeChanged"
    />
    <ag-grid-vue
      class="ag-theme-alpine"
      :pagination="true"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="rowData"
      :gridOptions="gridOptions"
      :paginationPageSize="paginationPageSize"
      @gridReady="onGridReady"
      @cellClicked="onCellClicked"
      rowSelection="single"
      domLayout="autoHeight"
    ></ag-grid-vue>
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue';
import GridMixin from '@/views/components/grids/GridMixin';
import {
  gridColumns,
  gridDefaultColDef,
} from '@/views/components/grids/awards/ReferencesGrid';

export default {
  name: 'ReferencesTable',
  components: {
    AgGridVue,
  },
  mixins: [GridMixin],
  props: {
    references: Array,
  },
  data() {
    return {
      rowData: this.references,
      defaultColDef: gridDefaultColDef,
      columnDefs: gridColumns,
    };
  },
  methods: {
    onCellClicked({ data }) {
      this.$router.push({
        name: 'ReferencesEdit',
        params: {
          reference: data.id,
        },
      });
    },
  },
  watch: {
    references() {
      this.rowData = this.references;
    },
  },
};
</script>
